import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  artists: hasMany('artist', { inverse: null }),
  calendarTypeId: belongsTo('category', { inverse: null }),
  categoryId: belongsTo('category', { inverse: null }),
  channelsAdditive: hasMany('channel', { inverse: null }),
  channelsExcluded: hasMany('channel', { inverse: null }),
  channelsExclusive: hasMany('channel', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  ownedByChannel: belongsTo('channel', { inverse: null }),
});
